document.addEventListener("DOMContentLoaded", () => {
  const posters = document.querySelectorAll(".video-section__poster");

  posters.forEach((poster) => {
    // lancer automatiquement après un court délai
    setTimeout(() => {
      poster.click();
    }, 300);
  });
});
// Lance automatiquement les vidéos des sections Shopify une fois la landing fermée
document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("landingVideoOverlay");

  if (!overlay) return;

  const observer = new MutationObserver(() => {
    if (overlay.style.display === "none") {
      // Quand la landing est fermée → lancer la vidéo Dawn
      const deferredButton = document.querySelector(".deferred-media__poster");
      if (deferredButton) {
        deferredButton.click();
      }
    }
  });

  observer.observe(overlay, { attributes: true, attributeFilter: ["style"] });
});
